import { Injectable } from '@angular/core';
import { SETTINGS } from '../configs/common.settings';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActionLogService {
  actionLogDataOnChange = new BehaviorSubject([]);

  constructor(private http: HttpClient) {}

  getAllLogsById(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/audit/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            this.actionLogDataOnChange.next(response);
            resolve(response);
          },
          error: (error: any) => {
            if (error.status === 403 || error === 403) {
            }
            reject(error.error.message);
          },
        });
    });
  }
}
